import React from "react";
import "./ToDoTask.css";
import Blue_btn from "../../../../../common_components/common_btn/blue_btn/Blue_btn";
import { Table } from "react-bootstrap";

function ToDoTask() {
  const tasks = [
    "Upload Certificate",
    "Submit Visa",
    "Confirm Flight",
    "Upload Insurance",
    "Upload Certificate",
    "Submit Visa",
    "Confirm Flight",
    "Upload Insurance",
    "Upload Certificate",
    "Submit Visa",
    "Confirm Flight",
    "Upload Insurance",
    "Upload Certificate",
    "Submit Visa",
    "Confirm Flight",
    "Upload Insurance",
  ];

  const percent = 57;

  return (
    <div className="Dashboard__ToDoTask card_box">
      <h5 className="mb-3 card_heading_holder">To-Do Task</h5>

      <div className="circle_wrapper">
        <div className="circular_progress" style={{ "--progress": percent }}>
          <div className="inner_text">
            <h3>{percent}%</h3>
            <p>Complete</p>
          </div>
        </div>
      </div>

      <div className="custom_table ">
        <Table borderless responsive>
          <tbody>
            {tasks.map((task, index) => (
              <tr key={index}>
                <td>
                  {" "}
                  <Blue_btn btn_text="Upload" />
                </td>

                <td>{task}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default ToDoTask;
